import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Services from '../../services/service';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import BasFloorAccordion from './BasFloorAccordion';
import ModalAddForm from './ModalAddForm';
import withNotification from '../../components/HOCNotification/HOCNotification.component';

class BasControl extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataBAS: [],
      activeTab: undefined,
      openModalAdd: false,
    };
    this.initialState = this.state;
    this.toggleModalAdd = this.toggleModalAdd.bind(this);
  }

  componentDidMount() {
    this.getDataBasControl();
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleModalAdd = () => {
    this.setState({ openModalAdd: !this.state.openModalAdd })
  }

  getDataBasControl = () => {
    Services.getBasControl()
      .then(res => {
        this.setState({ dataBAS: res, activeTab: res?.[0]?.id });
      })
      .catch(err => console.log(err));
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item">Dashboard</li>
        <li className="breadcrumb-item active">BAS Control</li>
      </ol>
      <h1 className="page-header">BAS Control</h1>
    </div>
  );

  render() {

    const { dataBAS, openModalAdd } = this.state;

    return (
      <div>
        {this.renderBreadcrumb()}
        <div>
          <div className='d-flex flex-row justify-content-between'>
            <Nav tabs>
              {dataBAS.map(item => (
                <NavItem key={item.id}>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === item.id })}
                    onClick={() => { this.toggleTab(item.id); }}
                  >
                    <span>{item.building}</span>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <div>
              <button className="btn btn-sm btn-primary" onClick={this.toggleModalAdd}>
                <i className='fa fa-plus mr-1' />Tambah BAS Control
              </button>
            </div>
          </div>

          <TabContent activeTab={this.state.activeTab}>
            {dataBAS.map(item => (
              <TabPane tabId={item.id} key={item.id}>
                <div id={`accordion${item.id}`} className="accordion">
                  <BasFloorAccordion
                    floor={item.floor}
                  />
                </div>
              </TabPane>
            ))}
          </TabContent>
        </div>
        {openModalAdd &&
          <ModalAddForm
            isOpen={openModalAdd}
            toggle={this.toggleModalAdd}
            getDataBasControl={this.getDataBasControl}
            addNotification={this.props.addNotification}
          />
        }
      </div>
    )
  }
}

export default withNotification(BasControl);
